import api from "api/axios";

export const fetchEventCategoriesTree = (payload) =>
  api.post("/event-categories/search", payload);

export const fetchOrganizerEventCategories = (companyId) =>
  api.get(`/event-categories/company/${companyId}`);

export const createEventCategory = (payload) =>
  api.post("/event-categories", payload);

export const updateEventCategory = (id, payload) =>
  api.put(`/event-categories/${id}`, payload);

export const deleteEventCategory = (id, payload) =>
  api.put(`/event-categories/delete/${id}`, payload);
